export const Sizes = [
  {
    id: 1,
    size: 5,
  },
  {
    id: 2,
    size: 10,
  },
  {
    id: 3,
    size: 25,
  },
  {
    id: 4,
    size: 50,
  },
  {
    id: 5,
    size: 75,
  },
  {
    id: 6,
    size: 100,
  },
];
